import { differenceInCalendarMonths } from "date-fns";
import { useMemo } from "react";
import { useGoalsQuery } from "web_myplann/Api/Goals/useGoalsQuery";
import { mapGoalListItemDto } from "web_myplann/Goals/Mappers/mapGoalListItemDto";
import type { Goal } from "web_myplann/Goals/Types/GoalTypes";
import { GoalStateEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Translate = ReturnType<typeof useResource>["t"];

const formatDueIn = (
	targetDate: string | null | undefined,
	t: Translate,
): string => {
	if (!targetDate) return "";
	const months = Math.max(
		0,
		differenceInCalendarMonths(new Date(targetDate), new Date()),
	);
	if (months >= 12) {
		return t(Resources.Goals.List.DueIn.Years, {
			count: Math.floor(months / 12),
		});
	}
	return t(Resources.Goals.List.DueIn.Months, { count: months });
};

export const useActiveGoals = (): { goals: Goal[]; isPending: boolean } => {
	const { t } = useResource();
	const { data: goalsResponse, isPending } = useGoalsQuery([
		GoalStateEnum.Created,
		GoalStateEnum.Active,
	]);

	const goals = useMemo(
		() =>
			(goalsResponse?.data ?? []).map((dto) =>
				mapGoalListItemDto({ dto, dueIn: formatDueIn(dto.targetDate, t) }),
			),
		[goalsResponse, t],
	);

	return { goals, isPending };
};
